/**
 * Public-safe client config. Build-time only.
 * Allowed: PUBLIC_SERVER_URL + build id.
 * Forbidden: keys, DB URLs, JWTs, admin tokens, Pie / machine paths.
 */
export const PUBLIC_SERVER_URL = __PUBLIC_SERVER_URL__;
export const BUILD_ID = __PUBLIC_BUILD_ID__;

export const KNOWN_INTENTS = ['move', 'bank', 'extract', 'mark'] as const;
export type KnownIntent = (typeof KNOWN_INTENTS)[number];

export function serverIsConfigured(): boolean {
  return PUBLIC_SERVER_URL.length > 0;
}

export function intentUrl(): string {
  return `${PUBLIC_SERVER_URL}/intent`;
}

export function joinUrl(): string {
  return `${PUBLIC_SERVER_URL}/join`;
}

export function healthUrl(): string {
  return `${PUBLIC_SERVER_URL}/health`;
}
